import api from "APP_ROOT/api";
import { createChannel } from "APP_ROOT/cable";
import { SUCCESS } from "LIB/submission/constants";
import { buildAttachments } from "MODULES/Receiving/actions";
import { fetchSalesOrderWithAllLineItems } from "MODULES/SalesOrders/actions";
import pagination from "./pagination";

export const { pageActions: dashboardPageActions, stateLocator } = pagination;

export function create({ formData }) {
  return dispatch =>
    Promise.all(
      (formData.attachments || [])
        .map(attachment =>
          (attachment.files || [{}]).map(f => ({
            file: f,
            ...attachment
          }))
        )
        .flat()
        .map(buildAttachments)
    )
      .then(attachments => {
        const shipment = Object.assign({}, formData, {
          attachments
        });
        return api.shipments.create(shipment).then(() => {
          dispatch(reloadSilent());
          return SUCCESS;
        });
      })
      .catch(e => Promise.reject(e));
}

export function save(id, formData) {
  return dispatch =>
    Promise.all(
      (formData.attachments || [])
        .map(attachment => {
          attachment.files = attachment.files || [{}];

          return attachment.files.map(f => ({
            file: f,
            ...attachment
          }));
        })
        .flat()
        .map(buildAttachments)
    ).then(attachments => {
      const formattedData = Object.assign({}, formData, {
        attachments
      });
      return api.orders.warehouse_pick(id, formattedData).then(() => {
        dispatch(reloadSilent());
        return SUCCESS;
      });
    });
}

export function toggleAsyncPicked(order) {
  const serializedUser = JSON.parse(window.localStorage.getItem("user"));

  const data = {
    picked: !order.picked,
    picked_details: {
      picked_at: new Date(),
      picked_by: {
        id: !order.picked && serializedUser.id,
        name: serializedUser.full_name
      }
    }
  };
  return dashboardPageActions.updateAsync(
    order.id,
    data,
    api.inventories.togglePick(order.order_id, { type: order.type })
  );
}

let channel = null;

export function buildFilters(paginator) {
  const params = paginator.get("filters").toJS();
  const limit = paginator.get("pageSize");
  const page = paginator.get("page");

  return { limit, page, ...params };
}

export function reloadSilent(salesOrderDetail = false) {
  return (dispatch, getState) => {
    if (salesOrderDetail) {
      const salesOrderID = getState().salesOrderDetail.getIn([
        "salesOrder",
        "id"
      ]);

      if (salesOrderID) {
        return dispatch(fetchSalesOrderWithAllLineItems(salesOrderID));
      }
    }
    const currentState = getState();
    const paginator = stateLocator(currentState);
    const filters = buildFilters(paginator);

    return api.outboundOrders.search(filters).then(({ data }) => {
      dispatch(dashboardPageActions.resetResults(data.results));
    });
  };
}

export function unsubscribe() {
  return () => {
    if (channel) {
      channel.unsubscribe();
      channel = null;
    }
  };
}

export function onDisconnect() {
  return unsubscribe();
}

export function subscribe(onReceive = reloadSilent) {
  return dispatch => {
    if (!channel) {
      const { listen } = createChannel();

      channel = listen("OutboundOrdersChannel", {
        onDisconnect,
        onReceive: data => {
          if (["SHIPPED", "CREATE", "UPDATED"].includes(data.action)) {
            dispatch(onReceive());
          }
        }
      });
    }
  };
}



// WEBPACK FOOTER //
// ./app/modules/Shipping/actions.js